import React, { useEffect, useState } from "react";
import BrandAccessDetails from "../../../../../components/customers/customer-details/brandaccessdetails";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { CustomerTempContainer } from "../../../../../components/customers/customer-details/container";
import Loader from "../../../../../ui/loader";
import { GetPricingGroupsOfBrand } from "../../../../../components/brands/service/BrandService";

export default function BrandAccessEditPage() {
  const [loading, setLoading] = useState(false);
  const [priceGroups, setPriceGroups] = useState([]);
  const dispatch = useDispatch();
  const container = CustomerTempContainer(dispatch);
  let { id } = useParams();
  const brandsAccesses = useSelector(
    (state) => state.customerTempReducer.selectedBrandsAccess
  );
  const brandAccess = brandsAccesses.find((item) => item.id == id);
  let initForm = !!brandAccess ? brandAccess : {};
  const [form, setForm] = useState(ModifyInitForm(initForm));
  /**
   * Modify the initial form by extracting the Price Group Name from the pricing level
   * and returning the modified form.
   *
   * @param {object} initForm - The initial form to be modified.
   * @return {object} The modified form with the extracted Price Group Name.
   */
  function ModifyInitForm(initForm) {
    try {
    let priceGroupName = initForm?.pricingLevel.name;
    if (initForm?.pricingLevel.status == "Default")
      priceGroupName += " (Default)";
    return {
      name: initForm?.name,
      status: initForm?.status,
      pricingLevel: priceGroupName,
    };
  } catch (error) {
    console.log(error);
    return "";
  }
  }

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        let response = await GetPricingGroupsOfBrand(brandAccess.brandId);
        setPriceGroups(response.data);
      } catch (error) {
        console.log(error);
      }
      setLoading(false);
    })();
  }, []);

  function Save() {
    const brandToSave = brandAccess;
    brandToSave.status = form.status;
    brandToSave.pricingLevel = priceGroups.find((el) => {
      if (form.pricingLevel?.includes("Default")) {
        return el.status == "Default";
      }
      return el.name == form.pricingLevel;
    });
    container.UpdateBrandAccess(brandToSave);
  }
  return (
    <div>
      {loading ? (
        <Loader></Loader>
      ) : (
        <BrandAccessDetails
          form={form}
          setForm={setForm}
          Save={Save}
          priceGroups={priceGroups}
        ></BrandAccessDetails>
      )}
    </div>
  );
}
